import { render } from "./TheCarsGenerals.vue?vue&type=template&id=7f3eda11"
import script from "./TheCarsGenerals.vue?vue&type=script&lang=js"
export * from "./TheCarsGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__